import type { PressureCardId } from '@/content/data/pressure-cards';

/**
 * Threat plates for overlay grids — Figma “Threat Images” `1163:49184` @ 2× JPG
 * (397×328). `invasive-species` is not in that group; uses the pressure-card photo
 * cropped to the same size until a dedicated plate is added.
 */
export const overlayThreatImages: Record<PressureCardId, string> = {
  agriculture: '/media/overlay-threats/agriculture.jpg',
  'climate-change': '/media/overlay-threats/climate-change.jpg',
  'hunting-trapping': '/media/overlay-threats/hunting-trapping.jpg',
  pollution: '/media/overlay-threats/pollution.jpg',
  'urban-development': '/media/overlay-threats/urban-development.jpg',
  'human-disturbance': '/media/overlay-threats/human-disturbance.jpg',
  fisheries: '/media/overlay-threats/fisheries.jpg',
  'energy-infrastructure': '/media/overlay-threats/energy-infrastructure.jpg',
  logging: '/media/overlay-threats/logging.jpg',
  'invasive-species': '/media/overlay-threats/invasive-species.jpg',
};
